import { Injectable } from '@angular/core';

/**
 * 存儲開發模式的service
 */
@Injectable({
  providedIn: 'root',
})
export class DevService {
  private dev: boolean = true; // true: 開發模式, false: 生產模式

  isDev(): boolean {
    return this.dev;
  }
}
